// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"96861e21c1cc89ace293","655":"d6c2573649c937cb25ba"}[chunkId] + ".js";
};